var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"notification"},[_c('img',{attrs:{"src":_vm.loadSuccessIcon}}),_c('p',[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }